import { render } from "./EditOrderModal.vue?vue&type=template&id=ae5667ce&scoped=true"
import script from "./EditOrderModal.vue?vue&type=script&lang=js"
export * from "./EditOrderModal.vue?vue&type=script&lang=js"

import "./EditOrderModal.vue?vue&type=style&index=0&id=ae5667ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5667ce"]])

export default __exports__